export const GLOBAL_CONFIG = {
  isDev: process.env.NEXT_PUBLIC_IS_DEVELOPMENT === 'true',
  socketHost: process.env.NEXT_PUBLIC_SOCKET_HOST || '',
  apiHost: process.env.NEXT_PUBLIC_API_HOST || '',
  host: process.env.NEXT_PUBLIC_HOST || '',
  isLocalEnv: process.env.NEXT_PUBLIC_ENVIRONMENT === 'local',
  basePath: process.env.NEXT_PUBLIC_BASE_PATH || '',
} as const;
